<div class="ng-bento">
	<div
		[bentoBusyLoader]="isLoadingDashboardLayout"
		class="dashboard-bento-loader"
	></div>
</div>
<div class="staff-dashboard-ng" [style]="dashboardStyle2">
	<div
		class="ng-bento staff-dashboard-ng"
		[class.hidden]="isLoading"
		*ngIf="initialized"
		[style]="dashboardStyle"
	>
		<div
			class="onvio-setup"
			*ngIf="!hasSetupAssistantAccess && wizardTranslationsLoaded"
		>
			<cc-wizard-startup
				[hidden]="isEditMode"
				[definition]="wizardDefinition"
				[landingPageDefinition]="wizardLandingPageDefinition"
				(openmodal)="
					wizardOpenModal.emit({
						value: $event.value,
						sectionId: $event.sectionId
					})
				"
			></cc-wizard-startup>
			<h1 class="sr-only" translate="Bluemoon.Shell.Navigation.Home"></h1>
		</div>
		<lib-dashboard
			[customBackground]="'no-background'"
			[preferences]="preferences"
			(save)="onSave($event)"
			[isEditable]="isEditable"
			(editModeChange)="onEditModeChange($event)"
			(contentInitialized)="onContentInitialized($event)"
		>

			<lib-section
				[header]="'onvio.dashboard.setupGuide' | translate"
				icon="bento-icon-history"
				*ngIf="hasSetupPermission"
				(sectionIsVisible)="onSectionIsVisible($event)"
				(widgetIsVisible)="onWidgetIsVisible($event)"
			>
				<lib-widget
					[header]="'onvio.dashboard.setupGuide' | translate"
					[name]="'setup-module'"
					[hideCard]="true"
				>
					<ng-content select="#setup-module"></ng-content>
				</lib-widget>
			</lib-section>

			<lib-section
				[header]="'onvio.dashboard.trial' | translate"
				icon="bento-icon-clock"
				*ngIf="hasTrialPermission"
				(sectionIsVisible)="onSectionIsVisible($event)"
				(widgetIsVisible)="onWidgetIsVisible($event)"
			>
				<lib-widget
					[header]="'onvio.dashboard.trial' | translate"
					[name]="'trial-purchase'"
					[hideCard]="true"
				>
					<ng-content select="#trial-purchase"></ng-content>
				</lib-widget>
			</lib-section>

			<lib-section
				sectionId="my-center"
				[header]="'Onvio.Dashboard.MyCenter' | translate"
				icon="bento-icon-user"
				(sectionIsVisible)="onSectionIsVisible($event)"
				(widgetIsVisible)="onWidgetIsVisible($event)"
			>

				<!-- My Assignments Widget -->
				<lib-widget
					id="my-assignments-widget-container"
					[header]="'onvio.dashboard.myAssignments' | translate"
					[name]="'my-assignments-widget'"
					*ngIf="hasMyAssignmentsPermission"
				>
					<ng-content select="#my-assignments-widget"></ng-content>
				</lib-widget>
				<lib-widget
					[header]="'onvio.dashboard.staffAvailability' | translate"
					[name]="'availability'"
				>
					<ng-content select="#availability"></ng-content>
				</lib-widget>
				<lib-widget
					[header]="'onvio.dashboard.CheckpointNews' | translate"
					*ngIf="hasAUPermission"
				>
					<au-tax-content-widget id="taxcontent"></au-tax-content-widget>
				</lib-widget>

				<lib-widget
					[header]="'onvio.dashboard.LodgementPerformance' | translate"
					*ngIf="showLDGPRGMWidget"
				>
					<autax-lodge-performance
						id="taxLodgePerformance"
					></autax-lodge-performance>
				</lib-widget>

				<lib-widget
					[header]="'onvio.video.visible.preview.mode.only' | translate"
					[name]="'bm-overview-widget'"
					*ngIf="hasPreviewPermission"
				>
					<ng-content select="#onvio-overview"></ng-content>
				</lib-widget>
				<lib-widget
					[header]="'onvio.dashboard.timeRecap' | translate"
					[name]="'bm-time-recap-widget'"
					*ngIf="hasTimeRecapPermission"
				>
					<ng-content select="#bm-time-recap-widget"></ng-content>
				</lib-widget>
			</lib-section>

			<!-- Other Applications Widget -->
			<lib-section *ngIf="hasOtherApplications" sectionId="my-application" [header]="'Onvio.Dashboard.MyApplications' | translate" icon="bento-icon-grid"
				[name]="'Applications'">
				<ng-container *ngIf="isSaffronWidget; else legacyWidget" class="my-applications" id="my-application">
					<lib-widget class="my-applications-widget-container"
						[header]="'Onvio.Dashboard.Widgets.OtherApplications' | translate" [name]="'other-applications-widget'"
						*ngIf="hasOtherApplications">
						<app-other-applications-widget class="my-applications"
							[isUsingLatestSaffron]="true"></app-other-applications-widget>
					</lib-widget>
				</ng-container>

				<ng-template #legacyWidget>
					<lib-widget [header]="'Onvio.Dashboard.Widgets.OtherApplications' | translate"
						[name]="'other-applications-widget'" *ngIf="hasOtherApplications">
						<app-other-applications-widget></app-other-applications-widget>
					</lib-widget>
				</ng-template>
			</lib-section>

			<lib-section sectionId="help-how" [header]="'onvio.dashboard.helpCenter' | translate" icon="bento-icon-question"
				[name]="'Help'" *ngIf="!hasBrazilAccess" (sectionIsVisible)="onSectionIsVisible($event)"
				(widgetIsVisible)="onWidgetIsVisible($event)">
				<lib-widget [header]="'onvio.dashboard.helpWidget.videoLibrary' | translate"
					[name]="'bm-help-widget'">
					<ng-content select="#bm-help-widget"></ng-content>
				</lib-widget>
				<lib-widget [header]="'onvio.dashboard.helpWidget.helpTopics' | translate" [name]="'bm-common-articles'">
					<ng-content select="#bm-common-articles"></ng-content>
				</lib-widget>
			</lib-section>
		</lib-dashboard>
	</div>
</div>
